import React from "react";
import "./index.css";
import App from "./App";
import { ThemeProvider, createTheme } from "@mui/material";
import { blue, cyan, green, grey, lightBlue, pink, purple, red, teal } from "@mui/material/colors";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

const theme = createTheme({
  
  components: {
    MuiIconButton: {
      styleOverrides: {
        sizeMedium: {
          color:blue[900]
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: blue[900]
        }
      }
    }
  
  },
  palette: {
    primary: {
      main: teal[500],
      light:grey[50]
    },
    secondary: {
      main: pink[500],
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root")  as HTMLElement);
root.render(
  // <React.StrictMode>
 <ThemeProvider theme={theme}>
     <App />
     </ThemeProvider>
  // </React.StrictMode>
);

reportWebVitals();

// ReactDOM.render(
//   <React.StrictMode>
//     <ThemeProvider theme={theme}>
//     <App />
//     </ThemeProvider>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
